import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import FraudioLoader from "../FraudioLoader";
import {Helmet} from "react-helmet";


export default function RssFeedList({
                                        feedUrl = "https://feeds.simplecast.com/xZFNy8N_",
                                        pageSize = 10,
                                        pagination = true,
                                    }) {
    const [items, setItems] = useState([]);
    const [channel, setChannel] = useState(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    // Infinite scroll
    const [page, setPage] = useState(1);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const sentinelRef = useRef(null);

    function truncateToWords(str, wordLimit = 30) {
        const words = str.trim().split(/\s+/);
        if (words.length <= wordLimit) return str;
        return words.slice(0, wordLimit).join(' ') + '...';
    }


    useEffect(() => {
        let cancelled = false;

        async function load() {
            setLoading(true);
            setError("");

            try {
                const res = await axios.get(feedUrl, {
                    responseType: "text",
                    headers: { Accept: "application/rss+xml, application/xml, text/xml" },
                });

                const { channelInfo, parsedItems } = parseRssXml(res.data);

                // sondan başa (yeniden eskiye)
                parsedItems.sort((a, b) => (b.pubDateMs ?? 0) - (a.pubDateMs ?? 0));

                if (!cancelled) {
                    setChannel(channelInfo);
                    setItems(parsedItems);
                    setPage(1);
                }
            } catch (e) {
                if (!cancelled) {
                    setError(
                        `Feed alınamadı. Olası neden: CORS/Network. Detay: ${
                            e?.message || String(e)
                        }`
                    );
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        }

        load();
        return () => {
            cancelled = true;
        };
    }, [feedUrl]);

    const totalCount = items.length;
    const visibleCount = pagination ? Math.min(totalCount, page * pageSize) : Math.min(totalCount, pageSize);
    const visibleItems = useMemo(
        () => items.slice(0, visibleCount),
        [items, visibleCount]
    );
    const hasMore = pagination && visibleCount < totalCount;

    useEffect(() => {
        if (!sentinelRef.current) return;
        if (!hasMore) return;

        const io = new IntersectionObserver(
            (entries) => {
                const first = entries[0];
                if (!first?.isIntersecting) return;

                // spam tetiklemeyi engellemek için basit kilit
                setIsLoadingMore(true);
                setPage((p) => p + 1);
                setTimeout(() => setIsLoadingMore(false), 150);
            },
            {
                root: null,
                rootMargin: "400px",
                threshold: 0.01,
            }
        );

        io.observe(sentinelRef.current);
        return () => io.disconnect();
    }, [hasMore]);

    if (loading) return <div>Yükleniyor…</div>;
    if (error) return <div style={{ color: "crimson" }}>{error}</div>;

    return (
        <React.Fragment>
            {channel && pagination ? (
                <div className="container" style={{ marginTop: 20 }}>
                    <div style={{ opacity: 0.85 }}>
                        Toplam: {totalCount} | Gösterilen: {visibleCount}
                    </div>
                </div>
            ) : null}

            {visibleItems.map((it, idx) => {
                const key = it.guid || it.link || `${it.title}-${idx}`;

                const imageUrl =
                   it.itunes?.imageHref ||
                    it.mediaThumbnail?.url  ||
                    ""; // boşsa img render etmeyiz

                const subtitle =
                    it.itunes?.subtitle ||
                    channel?.title ||
                    it.itunes?.author ||
                    "Podcast";

                const title = it.title || it.itunes?.title || "(Başlık yok)";

                // Description RSS'te HTML olabilir; düz metne çevirip kısaltıyoruz
                const desc = truncate(stripHtml(it.description || it.itunes?.summary || ""), 280);

                const audioSrc = it.enclosure?.url || ""; // FraudioLoader buradan çalacak

                const artist =
                    it.author ||
                    it.itunes?.author ||
                    channel?.title ||
                    "Yayın";

                return (
                    <div
                        key={key}
                        className="live-youtube-wrapper style-two pb-120 pt-120 mt-0"
                    >
                        <div className="container">
                            <div className="live-youtube style-two">
                                <div className="row gy-4 align-items-center">
                                    <div className="col-lg-4">
                                        <div className="youtube-rj">
                                            <div className="youtube-rj__thumb">
                                                {imageUrl ? (
                                                    <img src={imageUrl} alt={title} />
                                                ) : (
                                                    // Görsel yoksa boşluk kırılmasın diye basit placeholder
                                                    <div
                                                        style={{
                                                            width: "100%",
                                                            aspectRatio: "1 / 1",
                                                            border: "1px solid rgba(255,255,255,0.15)",
                                                            borderRadius: 8,
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-8 ps-lg-5 pe-lg-5">
                                        <div className="row">
                                            <div className="col-lg-7">
                                                <div className="youtube-content">
                                                    {pageSize==1 && <h6 className="youtube-content__subtitle">Son Eklenen Podcast</h6>}
                                                    <h3
                                                        className="youtube-content__title"
                                                        style={{ color: "#fff" }}
                                                    >
                                                        {truncateToWords(title,10)}
                                                    </h3>

                                                    <p className="youtube-content__desc">
                                                        {desc || "Açıklama bulunamadı."}
                                                    </p>

                                                    {it.pubDate ? (
                                                        <div style={{ opacity: 0.8, marginTop: 8 }}>
                                                            {it.pubDate}
                                                            {it.itunes?.duration
                                                                ? ` • Süre: ${it.itunes.duration}`
                                                                : ""}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>

                                            <div className="col-lg-12 mt-lg-0 mt-3">
                                                {audioSrc ? (
                                                    <FraudioLoader
                                                        src={truncateToWords(audioSrc,10)}
                                                        title={truncateToWords(title,10)}
                                                        artist={"Podcast"}
                                                    />
                                                ) : (
                                                    <div style={{ opacity: 0.85 }}>
                                                        Audio kaynağı (enclosure) bulunamadı.
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}

            {/* Infinite scroll sentinel */}
            <div ref={sentinelRef} style={{ height: 1 }} />

            {pagination && (
                <div className="container" style={{ marginBottom: 40 }}>
                    <div style={{ opacity: 0.85 }}>
                        {hasMore
                            ? (isLoadingMore ? "Daha fazla yükleniyor…" : "Aşağı kaydırınca devamı yüklenecek…")
                            : "Tüm kayıtlar yüklendi."}
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

/** XML -> channel + item[]  (namespace güvenli) */
function parseRssXml(xmlText) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlText, "text/xml");

    const parseError = doc.querySelector("parsererror");
    if (parseError) {
        throw new Error("XML parse hatası: " + (parseError.textContent || "parsererror"));
    }

    const channelNode = doc.getElementsByTagName("channel")?.[0] || null;

    const channelInfo = channelNode
        ? {
            title: getTextByTag(channelNode, "title"),
            link: getTextByTag(channelNode, "link"),
            description: getTextByTag(channelNode, "description"),
            language: getTextByTag(channelNode, "language"),
            lastBuildDate: getTextByTag(channelNode, "lastBuildDate"),
        }
        : null;

    const itemNodes = Array.from(doc.getElementsByTagName("item") || []);

    const parsedItems = itemNodes.map((itemNode) => {
        const pubDate = getTextByTag(itemNode, "pubDate");
        const pubDateMs = pubDate ? Date.parse(pubDate) : null;

        const enclosureNode = itemNode.getElementsByTagName("enclosure")?.[0] || null;
        const mediaThumbNode = itemNode.getElementsByTagName("media:thumbnail")?.[0] || null;
        const itunesImageNode = itemNode.getElementsByTagName("itunes:image")?.[0] || null;

        const itunes = {
            title: getTextByTag(itemNode, "itunes:title"),
            author: getTextByTag(itemNode, "itunes:author"),
            duration: getTextByTag(itemNode, "itunes:duration"),
            summary: getTextByTag(itemNode, "itunes:summary"),
            subtitle: getTextByTag(itemNode, "itunes:subtitle"),
            explicit: getTextByTag(itemNode, "itunes:explicit"),
            imageHref: itunesImageNode?.getAttribute("href") || "",
        };

        let rawItemXml = "";
        try {
            rawItemXml = new XMLSerializer().serializeToString(itemNode);
        } catch {
            rawItemXml = "";
        }

        return {
            guid: getTextByTag(itemNode, "guid"),
            title: getTextByTag(itemNode, "title"),
            description: getTextByTag(itemNode, "description"),
            pubDate,
            pubDateMs,
            author: getTextByTag(itemNode, "author"),
            link: getTextByTag(itemNode, "link"),

            enclosure: enclosureNode
                ? {
                    url: enclosureNode.getAttribute("url") || "",
                    type: enclosureNode.getAttribute("type") || "",
                    length: enclosureNode.getAttribute("length") || "",
                }
                : null,

            mediaThumbnail: mediaThumbNode
                ? {
                    url: mediaThumbNode.getAttribute("url") || "",
                    width: mediaThumbNode.getAttribute("width") || "",
                    height: mediaThumbNode.getAttribute("height") || "",
                }
                : null,

            itunes,
            rawItemXml,
        };
    });

    return { channelInfo, parsedItems };
}

function getTextByTag(parent, tagName) {
    if (!parent || !tagName) return "";
    const nodes = parent.getElementsByTagName(tagName);
    if (!nodes || !nodes.length) return "";
    return (nodes[0].textContent || "").trim();
}

function stripHtml(html) {
    if (!html) return "";
    // basit HTML temizliği (description HTML gelebilir)
    return html
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
        .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "")
        .replace(/<\/?[^>]+(>|$)/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}

function truncate(text, maxLen) {
    if (!text) return "";
    if (text.length <= maxLen) return text;
    return text.slice(0, maxLen - 1).trim() + "…";
}
